/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_Document_ComparisonInputs */

const en_page_title_document_comparison = /** @type {(inputs: Page_Title_Document_ComparisonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document comparison`)
};

const nl_page_title_document_comparison = /** @type {(inputs: Page_Title_Document_ComparisonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentvergelijking`)
};

/**
* | output |
* | --- |
* | "Document comparison" |
*
* @param {Page_Title_Document_ComparisonInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_document_comparison = /** @type {((inputs?: Page_Title_Document_ComparisonInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_Document_ComparisonInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_document_comparison(inputs)
	return en_page_title_document_comparison(inputs)
});